import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { number } from "../../../config";
import { getUserOverviewTasks } from "../../TeamSetting/TeamLeftSetting/teamSetting.service";

export const useUserProfileProjects = () => {
  const projects = useSelector((state) => state.allProjects.data);
  const { userProjects, visitingByAdmin } = useSelector((state) => state.userDetails);
  const allProjects = visitingByAdmin ? userProjects : projects;
  return allProjects?.filter((project) => project.IsPersonal !== number.ONE);
};

export const useGetUser = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  const { visitingByAdmin, details } = useSelector((state) => state.userDetails);
  const user = visitingByAdmin ? { ...details, companyId: loggedInUser?.companyId } : loggedInUser;
  return user;
};

/**
 * Custom hook to fetch user overview tasks
 * @author Bhavana
 */
export const useUserOverviewTasks = (selectedDuration) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { positionId } = useSelector((state) => state.userPosition);
  const { visitingByAdmin, details } = useSelector((state) => state.userDetails);
  const { teamSavedFilters } = useSelector((state) => state.teamFilter);

  const fetchUserOverviewTasks = useCallback(async (newDuration) => {
    const projectId = visitingByAdmin ? details?.myProjectId : user?.myProjectId;
    const userId = visitingByAdmin ? details?.id : user?.id;

    if (!projectId || !userId || !teamSavedFilters) {
      return;
    }

    const allTaskFilter = teamSavedFilters?.find((f) => f.label === "All Task");
    if (!allTaskFilter?.value) {
      return;
    }

    const durationToUse = newDuration || selectedDuration;
    const endDate = new Date();
    const startDate = new Date();

    if (durationToUse && durationToUse.start && durationToUse.end) {
      startDate.setTime(durationToUse.start.getTime());
      endDate.setTime(durationToUse.end.getTime());
    } else {
      startDate.setDate(startDate.getDate() - 30);
    }

    const payload = {
      positionId,
      overviewStartDate: format(startDate, "yyyy-MM-dd"),
      overviewEndDate: format(endDate, "yyyy-MM-dd"),
      filterId: allTaskFilter.value,
      isOverview: number.ONE,
      projectId,
      userId,
    };

    await dispatch(getUserOverviewTasks(payload));
  }, [teamSavedFilters, visitingByAdmin, details, user, positionId, selectedDuration, dispatch]);

  return fetchUserOverviewTasks;
};
